import React from 'react';
import { business } from '../data/content';
import { LegalDocId } from '../data/legal';
type SiteFooterProps = {
  onOpenLegal: (doc: LegalDocId) => void;
};
export function SiteFooter({
  onOpenLegal
}: SiteFooterProps) {
  return <footer className="border-t border-stone-line bg-white" data-id="element-321" data-mp="3mfyfeb7tphqi">
      <div className="mx-auto flex max-w-7xl flex-col items-center px-5 py-12 text-center md:px-8 md:py-14" data-id="element-322" data-mp="3hizijkwrywom">
        <a href="#top" aria-label={`${business.name} home`} data-id="element-323" data-mp="3dh4j6lyemtdh">
          <img src={business.logo} alt={business.name} className="h-24 w-auto md:h-28" data-id="element-324" data-mp="38hrmzaln89y8" />
        </a>
        <p className="mt-3 max-w-sm text-sm leading-relaxed text-ink-muted" data-id="element-325" data-mp="33iou0oixtu6m">
          Family-owned stone work and landscaping. Licensed, insured, and local to North Dallas.
        </p>
      </div>
      <div className="border-t border-stone-line" data-id="element-326" data-mp="11rbpw1osnqbm">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-3 px-5 py-5 text-center text-sm text-ink-muted md:px-8" data-id="element-327" data-mp="11q0og8itmuno">
          <div className="flex gap-5" data-id="element-328" data-mp="wq4frvz6if1s">
            <button onClick={() => onOpenLegal('privacy')} className="font-medium transition-colors duration-150 hover:text-forest" data-id="element-329" data-mp="15qc1kfd4nhgh">
              Privacy Policy
            </button>
            <button onClick={() => onOpenLegal('terms')} className="font-medium transition-colors duration-150 hover:text-forest" data-id="element-330" data-mp="vtz91ktbj9nb">
              Terms of Service
            </button>
          </div>
          <p data-id="element-331" data-mp="1ojpel5gvx37t">
            © {new Date().getFullYear()} {business.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}